import { z } from 'zod';

export const wordSchema = z.object({
  start: z.number().nonnegative(),
  end: z.number().nonnegative(),
  text: z.string(),
  probability: z.number().min(0).max(1).optional(),
});

export const segmentSchema = z.object({
  id: z.number().int().nonnegative(),
  start: z.number().nonnegative(),
  end: z.number().nonnegative(),
  text: z.string(),
  words: z.array(wordSchema),
});

export const transcriptSchema = z.object({
  language: z.string(),
  languageProbability: z.number().optional(),
  duration: z.number().nonnegative(),
  segments: z.array(segmentSchema),
});

export type Word = z.infer<typeof wordSchema>;
export type Segment = z.infer<typeof segmentSchema>;
export type Transcript = z.infer<typeof transcriptSchema>;

export function transcriptText(t: Transcript): string {
  return t.segments.map((s) => s.text.trim()).join(' ');
}
